<template>
    <CCard style="height: 100%">
        <CCardHeader>
            <CRow>
                <CCol>
                    <CIcon :src="Logo" />
                    <p class="title mb-0 d-inline-block ml-2">Projects</p></CCol
                >
                <CCol class="py-0">
                    <div
                        class="d-flex ml-2 float-right h-100"
                        :class="selectedTab === 'INACTIVE' ? 'active-tab' : ''"
                        style="cursor: pointer"
                        @click="selectedTab = 'INACTIVE'"
                    >
                        <p class="my-auto">Inactive</p>
                    </div>
                    <div
                        class="d-flex mr-2 float-right h-100"
                        :class="selectedTab === 'ACTIVE' ? 'active-tab' : ''"
                        style="cursor: pointer"
                        @click="selectedTab = 'ACTIVE'"
                    >
                        <p class="my-auto mb-0">Active</p>
                    </div>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardHeader>
            <small>Project Name</small>
            <small class="float-right">Associated Timeline</small>
        </CCardHeader>
        <CCardBody>
            <CRow v-for="project in projects" :key="project.id">
                <CCol>
                    <p class="mb-0" style="font-weight: 600">
                        {{ project.name }}
                    </p>
                </CCol>
                <CCol>
                    <CBadge
                        :color="getColor(getMonth(project.target_date))"
                        shape="pill"
                        class="float-right px-2 py-2"
                        style="color: white"
                        >{{ getMonth(project.target_date) }} Months</CBadge
                    >
                </CCol>
            </CRow>
        </CCardBody>
    </CCard>
</template>

<script>
import gql from "graphql-tag";
import Logo from "../../../containers/sidebar-icons/Projects.svg";

export default {
    data() {
        return {
            Logo,
            projects: [],
            selectedTab: "ACTIVE",
        };
    },
    watch: {
        selectedTab() {
            if (this.selectedTab === "ACTIVE") this.getProjects(false);
            else this.getProjects(true);
        },
    },
    methods: {
        getMonth(date) {
            let d1 = new Date();
            let d2 = new Date(date);
            let months;

            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            return months <= 0 ? 0 : months;
        },
        getColor(months) {
            if (months >= 1 && months <= 8) return "success";
            else if (months >= 9 && months <= 16) return "warning";
            else return "danger";
        },
        getProjects(is_archived = false) {
            this.$apollo
                .mutate({
                    mutation: GET_PROJECTS,
                    variables: {
                        is_archived,
                    },
                })
                .then((res) => {
                    const result = res.data?.spendmd_db_project;
                    this.projects = result;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    beforeMount() {
        this.getProjects();
    },
};

const GET_PROJECTS = gql`
    query ($is_archived: Boolean) {
        spendmd_db_project(
            limit: 7
            where: { is_archived: { _eq: $is_archived } }
        ) {
            project_end
            project_start
            name
            id
            savings_target
            spendmd_opportunity
            status
            target_date
            anticipated_project_closure
            is_archived
            updates
        }
    }
`;
</script>

<style scoped>
.active-tab {
    border-bottom: 3px solid #5ad49b;
}
.active-tab p {
    font-weight: 700;
}
.title {
    text-align: left;
    font: normal normal normal 16px/24px Lato;
    letter-spacing: 0px;
    color: #1f2621;
    opacity: 1;
}
</style>